<div class="wrapper" (wheel)="onScrolledWrapper($event)">
  <mat-drawer-container class="sidenav-container" autosize [hasBackdrop]="true">
    <mat-drawer #drawer class="sidenav-content" mode="over" position="end" [autoFocus]="false">
      <app-cv-upload *ngIf="openUpload"></app-cv-upload>
      <app-cv-create *ngIf="openCreate"></app-cv-create>
    </mat-drawer>
    <app-navbar class="nav-bar"></app-navbar>
    <app-content class="content"></app-content>
  </mat-drawer-container>
</div>
